export function generateUUID() {
    var template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return template.replace(/[xy]/g, function (c) {
        var r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export function createBuffer(_a) {
    var channelData = _a.channelData, sampleRate = _a.sampleRate;
    var audioBuffer = new AudioBuffer({
        sampleRate: sampleRate,
        length: channelData[0].length,
        numberOfChannels: channelData.length,
    });
    for (var ch = 0; ch < channelData.length; ch++)
        audioBuffer.getChannelData(ch).set(channelData[ch]);
    return audioBuffer;
}
